module.exports = __webpack_public_path__ + "static/media/summary-min-caption.2f14a31c.gif";